import { Component } from '@angular/core';
import { User } from '../../../shared/models/auth';
import { Router } from '@angular/router';
import { environment } from "public/environments/environment";
import { Subscription } from 'rxjs';
import { NotificationsService } from 'projects/shared/src/services/notifications.service';
import { Notification, NotificationsModel } from 'projects/shared/src/models/Notification';
import { SignalEventType } from 'projects/shared/src/models/SignalModel';
import { SignalRService } from 'projects/shared/src/services/signal-rservice.service';
import { AuthenticationService } from 'projects/shared/src/services/authentication.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  standalone: false
})
export class HeaderComponent {
  isOpened = false;
  currentUser: User | any = new User();

  userMenu = false;
  shouldShow = false;

  notifLoading = false;
  pageNumber = 1;
  pageSize = 10;
  pageCount: number = 0;
  notificationMenu = false;
  appRedirectUrl = environment.appRedirectAdminUrl
  notificationsResult: any = {
    unSeenNotificationsCount: 0,
    totalCount: 0,
  };
  notificationsList: Notification[] = [];
  subscriptions: Subscription[] = [];
  NotificationsModel = new NotificationsModel();
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private notificationsService: NotificationsService,
    private signal: SignalRService,
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.getNotifications();
  }

  ngOnInit() {

    this.subscriptions.push(
      this.signal.getDataStream<string>(SignalEventType.changeNotificationCount)
        .subscribe(message => {
          this.updateNotification(message.data);
        })
    )
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  updateNotification(data: any) {
    this.getNotifications();
  }

  // Actions
  changeLanguage() {
    if (localStorage.getItem('language') === 'en') {
      localStorage.setItem('language', 'ar');
    } else {
      localStorage.setItem('language', 'en');
    }
    window.location.reload();
  }
  logout() {
    this.authenticationService.logout();
    this.router.navigate(['/login']);
  }

  seeNotifications(notif: Notification) {
    this.notificationsService.SeeNotifications(notif.notificationId).subscribe(
      (result) => {
        this.notificationsResult.unSeenNotificationsCount = result
      }, err => {
        console.error(err);
      });
  }

  openNotificationPanel() {
    this.notificationMenu = !this.notificationMenu;
    this.userMenu = false;
    if (!this.notificationsList.length) {
      // this.getNotifications();
    }
  }

  getNextPage() {
    if (this.pageNumber < this.pageCount) {
      this.pageNumber += 1;
      this.getNotifications(false, true);
    }
  }
  getNotifications(update = true, isScroll = false) {
    if (update) {
      this.pageNumber = 1;
      this.notificationsList = [];
    }
    this.notifLoading = !isScroll;
    this.NotificationsModel.pageSize = this.pageSize;
    this.NotificationsModel.pageNumber = this.pageNumber;
    this.notificationsService.GetNotifications(this.NotificationsModel).subscribe(
      result => {
        this.notifLoading = false;
        this.notificationsResult = result;
        this.pageCount = Math.ceil(this.notificationsResult.totalCount / this.pageSize);
        this.notificationsList = this.notificationsList.concat(this.notificationsResult.pageData);
        // this.notificationsResult.unSeenNotificationsCount = 0;
      }, err => {
        this.notifLoading = false;
        console.error(err);
      });
  }

}
